export default __webpack_public_path__ + "static/media/imagePopupVertical.8a1d13d1.png";